import enterprise from '@/routers/enterprise'//企业服务
import account_setting from '@/routers/account_setting'//账户设置
import park_user from '@/routers/park_user'//园区用户
import service_provider from '@/routers/service_provider'//服务商
let children = [...enterprise, ...account_setting, ...park_user, ...service_provider]
const routers = [

  {
    path: '/personal_center',
    name: 'personal_center',
    meta: {
      exp: '个人中心',
      requireAuth: true
    },
    redirect: '/personal_center/park_user',
    component: () => import('@/views/personal_center/index.vue'),
    children: [
      ...children,
      {
        path: '/personal_center/help',
        name: 'personal_center/help',
        meta: {
          exp: '帮助中心',
          requireAuth: true
        },
        component: () => import('@/views/personal_center/help/index.vue'),
      },
      {
        path: '/personal_center/help/detail',
        name: 'personal_center/help/detail',
        meta: {
          exp: '帮助中心-详情',
          requireAuth: true
        },
        component: () => import('@/views/personal_center/help/detail/index.vue'),
      }
    ]
  },


]
export default routers
